import type { MarketingDoorId } from '~/marketing/landingContent';
import { BEACONS } from '../../prompts/prompts.generated';

/**
 * Which real beacon the hero's Circle shows, per page. Keys, not question text: the question comes
 * from prompts.generated.ts, which is synced to the backend banks, so the hero can only ever show a
 * prompt the app actually asks. circleFormingPrompt.test.ts fails if a key leaves the bank.
 *
 * Each pick echoes its door's headline:
 * - home: an evening worth staying for — the Circle promise in one line.
 * - him: a day with no plans — shows what you're into, the "ground you share" Signal Fire matches on.
 * - her: how you know you like someone — "see how someone shows up before you choose them".
 * - open: what friends come to you for — who you are to your people, friends first.
 *
 * Keep picks under MAX_QUESTION_CHARS. At 375px the card is ~177px wide inside a ~340px ring, and a
 * 72-character question grew it to 200px tall — into the nodes, with a one-word last line.
 */
export const MAX_QUESTION_CHARS = 62;

export const CIRCLE_FORMING_PROMPT_KEY: Record<MarketingDoorId | 'home', string> = {
  home: 'night_didnt_end',
  him: 'day_no_plans',
  her: 'how_you_know',
  open: 'come_to_you',
};

export function circleFormingQuestion(door?: MarketingDoorId): string {
  const key = CIRCLE_FORMING_PROMPT_KEY[door ?? 'home'];
  return (BEACONS.find((b) => b.key === key) ?? BEACONS[0]).question;
}
